import { formatNumber } from '@agro1desenvolvimento/utils-js';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import * as Yup from 'yup';
import { ptShort } from 'yup-locale-pt';

Yup.setLocale({
  ...ptShort,
  number: {
    ...ptShort.number,
    min: (event) => `Deve ser maior ou igual a ${formatNumber(event.min)}`,
    max: (event) => `Deve ser menor ou igual a ${formatNumber(event.max)}.`,
    lessThan: (event) => `Deve ser menor que ${formatNumber(event.less)}.`,
    moreThan: (event) => `Deve ser maior que ${formatNumber(event.more)}.`,
  },
});

export const validateSchemaSync = (
  schema: Yup.Schema,
  value: any,
  options?: Yup.ValidateOptions<any>,
) => {
  try {
    schema.validateSync(value, options);

    return true;
  } catch (error) {
    if (Yup.ValidationError.isError(error)) {
      return false;
    }

    throw error;
  }
};

export default Yup;
